import { render, staticRenderFns } from "./DonationPopup.vue?vue&type=template&id=3297c371"
import script from "./DonationPopup.vue?vue&type=script&lang=js"
export * from "./DonationPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports